import React from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import _ from 'lodash';
import ActionDelete from 'material-ui/svg-icons/action/delete';

export default class DropdownField extends React.Component {

  constructor(props) {
    super(props);
    var val = this.props.value ? this.props.value : "";
    this.state = {
      value: val,
    };
  }

  componentWillReceiveProps = (e) => {
    this.setState({
      value: e.value,
    });
  }
    
  handleChange = (event, index, value) => {
    this.setState({
      value: value,
    }, () => {
      if (this.props.onChange)
      {
        this.props.onChange();
      }
    });
  };

  handleDeleteClick = (e) => {
    this.setState({
      value: "",
    });    
  }
  render() {
    
    return (
      <div>
      <SelectField
          floatingLabelText={this.props.label}
          value={this.state.value}
          onChange={this.handleChange}
      >   
      {this.props.children}     
        {

          _.map(this.props.options, (opt, key) => {
            var _key = opt.key ? opt.key : key;
            var text = !this.props.renderText ? opt.name || opt.value || opt : this.props.renderText(opt)
            return (
              <MenuItem key={_key} value={_key} primaryText={text} />
            );
          })
        }      
      </SelectField>
      {this.props.clear ?
        <ActionDelete onClick={this.handleDeleteClick.bind(this)} />
          :
        <span></span>
      }
</div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/DropdownField.jsx